module.exports = __webpack_public_path__ + "img/Woori Finance.d7288d12.png";